module.exports = __webpack_public_path__ + "img/fg5.88af1cd8.jpg";